/**
 * Worker 消息类型枚举。
 */
export enum WorkerMessageType {
  /** 初始化 Worker。 */
  INIT = 'INIT',
  /** 执行单个命令。 */
  EXECUTE_COMMAND = 'EXECUTE_COMMAND',
  /** 生成几何网格。 */
  GENERATE_MESH = 'GENERATE_MESH',
  /** 仅从导入 BRep payload 恢复 Puppy CAD 内核 Shape，并注册为 STEP 导出基线。 */
  REGISTER_IMPORTED_BREP_SHAPE = 'REGISTER_IMPORTED_BREP_SHAPE',
  /** 在 active Worker GeometryState 中原子注册一组导入 BRep Shape。 */
  REGISTER_IMPORTED_BREP_SHAPES_ATOMICALLY = 'REGISTER_IMPORTED_BREP_SHAPES_ATOMICALLY',
  /** 提交或补偿回滚 active Worker 中尚未确认的 BRep 注册事务。 */
  COMPLETE_IMPORTED_BREP_REGISTRATION_TRANSACTION = 'COMPLETE_IMPORTED_BREP_REGISTRATION_TRANSACTION',
  /** 开始 staged Worker 几何运行时切换。 */
  BEGIN_GEOMETRY_RUNTIME_SWITCH = 'BEGIN_GEOMETRY_RUNTIME_SWITCH',
  /** 在 staged Worker 几何运行时中注册导入 BRep Shape。 */
  REGISTER_IMPORTED_BREP_SHAPE_IN_RUNTIME = 'REGISTER_IMPORTED_BREP_SHAPE_IN_RUNTIME',
  /** 在 staged Worker GeometryState 中原子注册一组导入 BRep Shape。 */
  REGISTER_IMPORTED_BREP_SHAPES_ATOMICALLY_IN_RUNTIME = 'REGISTER_IMPORTED_BREP_SHAPES_ATOMICALLY_IN_RUNTIME',
  /** 在 staged Worker 几何运行时中批量回放命令。 */
  BATCH_EXECUTE_IN_RUNTIME = 'BATCH_EXECUTE_IN_RUNTIME',
  /** 提交 staged Worker 几何运行时切换。 */
  COMMIT_GEOMETRY_RUNTIME_SWITCH = 'COMMIT_GEOMETRY_RUNTIME_SWITCH',
  /** 放弃 staged Worker 几何运行时切换。 */
  ABORT_GEOMETRY_RUNTIME_SWITCH = 'ABORT_GEOMETRY_RUNTIME_SWITCH',
  /** 将 Worker 当前持有的 live Puppy CAD 内核 Shape 序列化为 BRep 文本。 */
  EXPORT_BREP_SHAPES = 'EXPORT_BREP_SHAPES',
  /** 生成圆角预览。 */
  FILLET_PREVIEW = 'FILLET_PREVIEW',
  /** 在沙盒状态中生成圆角预览。 */
  FILLET_PREVIEW_IN_SANDBOX = 'FILLET_PREVIEW_IN_SANDBOX',
  /** 生成倒角预览。 */
  CHAMFER_PREVIEW = 'CHAMFER_PREVIEW',
  /** 在沙盒状态中生成倒角预览。 */
  CHAMFER_PREVIEW_IN_SANDBOX = 'CHAMFER_PREVIEW_IN_SANDBOX',
  /** 生成抽壳预览。 */
  SHELL_PREVIEW = 'SHELL_PREVIEW',
  /** 在沙盒状态中生成抽壳预览。 */
  SHELL_PREVIEW_IN_SANDBOX = 'SHELL_PREVIEW_IN_SANDBOX',
  /** 生成筋预览。 */
  RIB_PREVIEW = 'RIB_PREVIEW',
  /** 在沙盒状态中生成筋预览。 */
  RIB_PREVIEW_IN_SANDBOX = 'RIB_PREVIEW_IN_SANDBOX',
  /** 生成拉伸预览。 */
  EXTRUDE_PREVIEW = 'EXTRUDE_PREVIEW',
  /** 在沙盒状态中生成拉伸预览。 */
  EXTRUDE_PREVIEW_IN_SANDBOX = 'EXTRUDE_PREVIEW_IN_SANDBOX',
  /** 生成旋转预览。 */
  REVOLVE_PREVIEW = 'REVOLVE_PREVIEW',
  /** 在沙盒状态中生成旋转预览。 */
  REVOLVE_PREVIEW_IN_SANDBOX = 'REVOLVE_PREVIEW_IN_SANDBOX',
  /** 解析旋转拖拽轮廓。 */
  RESOLVE_REVOLVE_DRAG_CONTOURS = 'RESOLVE_REVOLVE_DRAG_CONTOURS',
  /** 查找草图区域。 */
  FIND_SKETCH_REGIONS = 'FIND_SKETCH_REGIONS',
  /** 获取 Worker 几何状态。 */
  GET_STATE = 'GET_STATE',
  /** 批量执行命令。 */
  BATCH_EXECUTE = 'BATCH_EXECUTE',
  /** 按 Feature 粒度提交成功前缀，并在首个 Feature error 处停止。 */
  EXECUTE_FEATURE_PREFIX_BATCH = 'EXECUTE_FEATURE_PREFIX_BATCH',
  /** 从 active Worker 当前历史位置查询无 Mesh topology checkpoint。 */
  QUERY_TOPOLOGY_CHECKPOINT = 'QUERY_TOPOLOGY_CHECKPOINT',
  /** Convert Entities 专用的当前 Face/Wire 只读查询。 */
  QUERY_CONVERT_ENTITIES_FACE_BOUNDARIES = 'QUERY_CONVERT_ENTITIES_FACE_BOUNDARIES',
  /** Convert Entities 按点击边查询其唯一直接 InnerWire。 */
  QUERY_CONVERT_ENTITIES_INNER_LOOP_BY_EDGE = 'QUERY_CONVERT_ENTITIES_INNER_LOOP_BY_EDGE',
  /** 释放已由特征重放接管的导入基线（离线包重开显示交接）。 */
  RELEASE_FEATURE_OWNED_BASELINES = 'RELEASE_FEATURE_OWNED_BASELINES',
  /** 获取指定网格。 */
  GET_MESH = 'GET_MESH',
  /** 回滚到指定状态。 */
  ROLLBACK = 'ROLLBACK',
  /** 创建状态快照。 */
  CREATE_SNAPSHOT = 'CREATE_SNAPSHOT',
  /** 清空 Worker 状态。 */
  CLEAR = 'CLEAR',
  /** 导出 STEP 文件。 */
  EXPORT_STEP = 'EXPORT_STEP',
  /** 计算二维曲线采样点。 */
  COMPUTE_2D_CURVE = 'COMPUTE_2D_CURVE',
}
